import './footer.scss';

export const Footer = () => {
    return (
        <section className='footer'>
            <div className="footer__copyright">
                Built by Tykhonenko Max
            </div>
        </section >
    )
}

export default Footer;
